import React from "react";

const GoogleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 533.5 544.3"
    width="20"
    height="20"
  >
    <path
      fill="#4285F4"
      d="M533.5 278.4c0-17.4-1.4-34.2-4.1-50.4H272v95.4h146.9c-6.3 34.2-25.5 63.1-54.7 82.6v68h88.4c51.8-47.7 81.9-118.1 81.9-195.6z"
    />
    <path
      fill="#34A853"
      d="M272 544.3c73.9 0 135.8-24.5 181-66.6l-88.4-68c-24.5 16.4-56 25.8-92.6 25.8-71 0-131.1-47.8-152.7-112.2H29.3v70.7C74.4 478.3 167.2 544.3 272 544.3z"
    />
    <path
      fill="#FBBC05"
      d="M119.3 327.2c-10.8-31.4-10.8-65.6 0-97l-90-70.7C8 200.8 0 236.6 0 272c0 35.4 8 71.2 29.3 112.5l90-57.3z"
    />
    <path
      fill="#EA4335"
      d="M272 107.6c38.5 0 73.1 13.2 100.3 39.1l75.1-75.1C407.9 24.5 345.9 0 272 0 167.2 0 74.4 66 29.3 162.8l90 70.7C140.9 155.4 201 107.6 272 107.6z"
    />
  </svg>
);

export default GoogleIcon;
